import { useState } from 'react'

import { caiEmit } from '@/embed/child/emit'
import { useIsEmbedded } from '@/embed/child/useIsEmbedded'

export function EmbedDemo() {
  const isEmbedded = useIsEmbedded()
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <main style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
        {!isEmbedded && <h1>Embed demo (running directly)</h1>}
        <p>This page can be loaded directly OR embedded via the CAI loader.</p>
        <button type="button" onClick={() => setExpanded((v) => !v)}>
          {expanded ? 'Collapse' : 'Expand'}
        </button>
        {expanded && (
          <div data-testid="expanded-content" style={{ height: 300, marginTop: 16, background: '#eef' }}>
            Extra content that changes the page height. The parent iframe should resize automatically.
          </div>
        )}
        <button
          type="button"
          data-testid="emit-button"
          onClick={() => caiEmit('demo-clicked', { ts: Date.now() })}
        >
          Emit event
        </button>
      </main>
    </>
  )
}
